/**
 * A helper function to wrap the Segment library in test-safe function calls
 */
const segment: Window["analytics"] = {
  load: (...args) => {
    window.analytics !== undefined && window.analytics["load"](...args);
  },
  identify: (...args) => {
    window.analytics !== undefined && window.analytics["identify"](...args);
  },
  track: (...args) => {
    window.analytics !== undefined && window.analytics["track"](...args);
  },
  page: (...args) => {
    window.analytics !== undefined && window.analytics["page"](...args);
  },
  group: (...args) => {
    window.analytics !== undefined && window.analytics["group"](...args);
  },
  alias: (...args) => {
    window.analytics !== undefined && window.analytics["alias"](...args);
  },
  reset: (...args) => {
    window.analytics !== undefined && window.analytics["reset"](...args);
  },
};

export default segment;
